(function () {
    'use strict';
    a3_pilot_reports.directive('crewMeals', crewMeals);

    /**
       * @memberof PilotReports
       * @ngdoc directive
       * @name crewMeals
       * @restrict E
       * @description
       *   Implementation of crew meals
       *
       *   Display the crew meals
       * @attr {String} dutyNo 
       * @attr {String} dutyDay  
       * @attr {String} flight-id
       * @example
       *   Usage:
       *   <crew-meals duty-no="137979375664" duty-day="13318" flight-id="123"></crew-meals>
       *   
       * @ngInject
       */
    function crewMeals(CrewRouteFactory, CrewMealFactory, FlightFactory, $sce, $timeout) {
        /**
         * Initialize crewMeals
         * @memberof crewMeals
         * @param {service} scope the scope of this element
         * @param {service} element element that this direcive is assigned to
         * @param {service} attributes attributes of this element
         */
        function link(scope, element, attributes) {
            scope.togglePanel = togglePanel;
            scope.route = CrewRouteFactory.getCrewRouteFromStorage(scope.dutyNo, scope.dutyDay);
            scope.HasRegChanged = false;
            scope.noClicked = noClicked;
            scope.yesClicked = yesClicked;
            scope.submitRatingClicked = submitRatingClicked;
            scope.canceClicked = canceClicked;
            scope.clearFormData = clearFormData;
            //for flight page
            scope.isFlightPanel = scope.flightId !== "";
            scope.flightCrewMeals = null;
            //for route page
            scope.isRoutePanel = scope.flightId == null || scope.flightId === "";
            scope.routeCrewMeals = [];
            scope.showCrewMealsPanel = false;
            //Rating Form
            scope.ratingForm = { CateringMealId: '', FlightId: '', Rating: '', Comments: '', DidNotEatReasonId: '' };
            scope.submitRatingMessage = '';
            scope.showPanel = "meals";
            scope.DidNotEatReasons = [];
            scope.isOffline = !window.navigator.onLine;

            scope.popoverInfo = {
                title: $sce.trustAsHtml(' Attention'),
                contentHtml: $sce.trustAsHtml('<div style="width:210px;">' +
                    'There is an aircraft change on your route. Please arrange to take your assigned meal with you.' +
                    '<div/>')
            };

            window.addEventListener('offline', function (e) { $timeout(scope.isOffline = !window.navigator.onLine); });
            window.addEventListener('online', function (e) { $timeout(scope.isOffline = !window.navigator.onLine); });

            //Get scope values
            if (scope.isFlightPanel && scope.route) {
                var crewMeals = scope.route.CrewMeals;
                for (var i = 0; i < crewMeals.length; i++) {
                    if (crewMeals[i].FlightId == scope.flightId) {
                        scope.flightCrewMeals = new FlightCrewMeal(crewMeals[i]);
                        scope.showCrewMealsPanel = true;
                        break;
                    }
                }
                scope.HasRegChanged = hasRegChanged(scope.flightId);
            }
            if (scope.isRoutePanel && scope.route && scope.route.CrewMeals.length > 0) {
                var crewMeals = scope.route.CrewMeals;
                for (var i = 0; i < crewMeals.length; i++) {
                    scope.routeCrewMeals.push(new FlightCrewMeal(crewMeals[i]));
                    scope.showCrewMealsPanel = true;
                }
                scope.HasRegChanged = hasRegChanged(crewMeals[0].FlightId);
            }

            if (!scope.isOffline && scope.showCrewMealsPanel) {
                CrewMealFactory.getCrewMealsDidNotEatReasons()
                    .then(res => scope.DidNotEatReasons = res);
            }

            //FlightCrewMeal Constructor
            function FlightCrewMeal(flight) {
                this.FlightDate = moment(flight.FlightDate).format("DD/MM");
                this.FlightNo = flight.FlightNo;
                this.FlightDeparture = flight.FlightDeparture;
                this.CrewMeals = "";
                this.CrewMealsDescriptions = [];

                for (var i = 0; i < Object.values(flight.CrewMealsCateringIds).length; i++) {
                    if (i != 0) {
                        this.CrewMeals += " & ";
                    }
                    var crewMealDetails = CrewMealFactory.getCrewMealFromStorage(Object.values(flight.CrewMealsCateringIds)[i]);
                    var hasRating = CrewMealFactory.hasRating(Object.keys(flight.CrewMealsCateringIds)[i]);
                    this.CrewMeals += crewMealDetails.Title;
                    this.CrewMealsDescriptions.push({ CrewMealId: Object.keys(flight.CrewMealsCateringIds)[i], CateringMealId: crewMealDetails.CateringMealId, Title: crewMealDetails.Title, Description: crewMealDetails.Description, HasRating: hasRating });

                }
            }

            //Change Registration check
            function hasRegChanged(flightId) {
                var retVal = false;
                var flights = FlightFactory.getFlightsByFlightId(flightId);
                if (flights.length > 0) {
                    var acTailNo = flights[0].AcTailNo;
                    for (var i = 0; i < flights.length; i++) {
                        if (flights[i].AcTailNo != acTailNo) {
                            retVal = true;
                            break;
                        }
                    }
                }
                return retVal;
            }

            /**
             * toggle Panel
             * @memberof crewMeals
             * @param {number} panelId
             */
            function togglePanel(panelId) {
                $('#' + panelId).toggle();
            }

            function noClicked(cateringMealId, crewMealId) {
                clearFormData(cateringMealId, crewMealId)
                scope.showPanel = "didNotEatMeal";
            }

            function yesClicked(cateringMealId, crewMealId) {
                clearFormData(cateringMealId, crewMealId);
                scope.showPanel = "mealRating";
            }

            //function checkConnection

            function clearFormData(cateringMealId, crewMealId) {
                scope.ratingForm.CateringMealId = cateringMealId;
                scope.ratingForm.FlightId = scope.flightId;
                scope.ratingForm.CrewMealId = crewMealId;
                scope.ratingForm.Rating = '';
                scope.ratingForm.DidNotEatReasonId = '';
                scope.ratingForm.Comments = '';
                scope.isOffline = !window.navigator.onLine
            }

            function canceClicked() {
                scope.showPanel = "meals";
            }

            function submitRatingClicked() {
                scope.showPanel = "loading";
                CrewMealFactory.sendCrewMealsRatingReport(this.ratingForm)
                    .then(res => handleSubmitResponse(res));

            }

            function handleSubmitResponse(res) {
                if (res.success) {
                    var index = scope.flightCrewMeals.CrewMealsDescriptions.findIndex((x => x.CateringMealId == scope.ratingForm.CateringMealId));
                    scope.flightCrewMeals.CrewMealsDescriptions[index].HasRating = true;
                    manageResponseMessage("success", res.message)
                }
                else {
                    manageResponseMessage("failure", res.message)
                }
            }

            function manageResponseMessage(panelToShow, message) {
                scope.submitRatingMessage = message;
                scope.showPanel = panelToShow;
                $timeout(function () { scope.showPanel = "meals"; }, 3000);
            }
        }

        return {
            restrict: 'E',
            terminal: true,
            templateUrl: 'views/directives/crewMeals.tpl.html',
            scope: {
                dutyNo: '@',
                dutyDay: '@',
                flightId: '@'
            },
            link: link
        }
    }

})();